<template>
  <div id="preloader">
    <div class="preloader">
      <div class="waviy">
        <span>G</span>
        <span>o</span>
        <span>P</span>
        <span>l</span>
        <span>a</span>
        <span>y</span>
        <span>T</span>
        <span>v</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PreLoader",
});
</script>
